import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCard from '../../../components/default/DefaultCard';
import ButtonCreate from '../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../components/default/DefaultModal';
import { useHistory } from 'react-router-dom';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import DefaultToolBar from '../../../components/default/DefaultToolBar';
import useSocietyClientService from '../../../app/services/hooks/useSocietyClientService';
import { SocietyClientDataForm, SocietyClientFilters } from '../../../app/models/SocietyClient';
import SocietyClientDataTable from './tables/SocietyClientDataTable';
import SocietyClientCreate from './SocietyClientCreate';
import SocietyClientEdit from './SocietyClientEdit';

interface Props {
    societyId: number;
    isShow?: boolean;
}

const SocietyClientContainer = ({ societyId, isShow = false }: Props) => {
    const history = useHistory();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {
        getSocietyClients,
        fetchingGetSocietyClients,
        deleteSocietyClient,
        fetchingDeleteSocietyClient,
    } = useSocietyClientService();

    const [showingCreate, setShowingCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);
  
    const [societyClientIdEdit, setSocietyClientIdEdit] = useState<number>(-1);
    const [societyClientIdShow, setSocietyClientIdShow] = useState<number>(-1);
    
    const [societyClients, setSocietyClients] = useState<SocietyClientDataForm[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);

    const [filter, setFilter] = useState<SocietyClientFilters>({
        society_id: societyId,
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'asc'
    });

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };


    const showEdit = (societyClientId: number) => {
        setShowingEdit(true);
        setSocietyClientIdEdit(societyClientId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setSocietyClientIdEdit(-1);
    };

    const showShow = (societyClientId: number) => {
       
        setShowingShow(true);
        setSocietyClientIdShow(societyClientId);
     };

    const hideShow = () => {
        setShowingShow(false);
        setSocietyClientIdShow(-1);
    };


    useEffect(() => {
        if (societyId) {
            reloadTable();
        }
    }, [filter, societyId]);

  
    const destroy = (societyClientId: number) => {
        const _text = 'Está a punto de eliminar el cliente #' + societyClientId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading)
                            showLoading('loading', 'Eliminando cliente...');
                        deleteSocietyClient(societyClientId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El cliente no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    const reloadTable = () => {
        const filtersWithSociety: SocietyClientFilters = {
            ...filter,
            society_id: societyId
        };
        
        getSocietyClients(filtersWithSociety, {
            onSuccess: (response: ServiceResponse) => {
                setSocietyClients(response.data.society_clients || []);
                setTotalRows(response.data.total_rows || 0);
               
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    return (
        <>
            <DefaultCard>
                <div className="h3 mt-0 mb-4 card-title">Clientes</div>
                <div className="row">
                    <div className="col-12">
                        {!isShow ? (
                            <DefaultToolBar left={<ButtonCreate callbackCreate={showCreate} />} />
                        ) : null}
                    </div>
                    <div className="col-12">
                        {isShow ? (
                            <SocietyClientDataTable
                                societyClients={societyClients}
                                loading={fetchingGetSocietyClients}
                                totalRows={totalRows}
                                filter={filter}
                                setFilter={setFilter}
                                callbackSuccess={reloadTable}
                            />
                        ) : (
                            <SocietyClientDataTable
                                societyClients={societyClients}
                                edit={showEdit}
                                destroy={destroy}
                                loading={fetchingGetSocietyClients}
                                totalRows={totalRows}
                                filter={filter}
                                setFilter={setFilter}
                                callbackSuccess={reloadTable}
                            />
                        )}
                    </div>
                </div>
            </DefaultCard>

            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Agregar cliente"
                    backdrop={true}
                    showFooter={false}
                >
                    <SocietyClientCreate
                        societyId={societyId}
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}
                    />
                </DefaultModal>
            ) : null}
            
            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title='Editar información cliente'
                    backdrop={true}
                    showFooter={false}
                >
                    <SocietyClientEdit
                        societyId={societyId}
                        societyClientId={societyClientIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        
                        onCancel={hideEdit}
                        onError={hideEdit}
                        
                    />
                </DefaultModal>
            ) : null} 

            {/* {showingShow ? (
                <DefaultModal
                    show={showingShow}
                    handleClose={hideShow}
                    title='Ver información cliente'
                    backdrop={true}
                    showFooter={false}
                >
                    <SocietyClientShow
                        societyClientId={societyClientIdShow}
                        onCancel={hideShow}
                        onError={hideShow}
                    />
                </DefaultModal>
            ) : null}  */}
        </>
    );
};

export default SocietyClientContainer;
